import React, { createContext, useMemo } from 'react';
import { SinglePriceConfigType } from '../../types/SinglePriceContent';

interface PriceConfigProviderProps {
  children: React.ReactNode;
  priceConfig: SinglePriceConfigType;
}

// This is injected to the application at root level, context will always have a value
export const priceContext = createContext<SinglePriceConfigType>({} as SinglePriceConfigType);
const { Provider } = priceContext;

const PriceConfigProvider: React.FC<PriceConfigProviderProps> = ({ children, priceConfig }) => {
  const dataBag = useMemo<SinglePriceConfigType>(() => priceConfig, [priceConfig]);
  console.log('dataBag in provider', dataBag);

  return <Provider value={dataBag}>{children}</Provider>;
};

export default PriceConfigProvider;
